import bill from "@/router/work/bill"   //退款管理
import invest from "@/router/work/invest"   //退款管理
export default
{
    path: "work",
    meta: {
        title: "账单管理"
    },
    component: () => import("@/layouts/item"),
    children: [
        bill,
        invest,

    ]
}

